// @flow

import React, { type Node } from 'react';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { getMoneyFormat } from '@tectonics/look-and-feel/shopify/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { PaymentInfo } from './payment-info';
import type { Country } from '@tectonics/prs/country';

export function DisplayTotalAmount(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const country = getCountry(incomingPayment);
  const decimalFormat = getMoneyFormat(country);
  const formatAmount = amountToCurrencyString(decimalFormat);

  return (
    <PaymentInfo label={getLabelValue(country)}>
      {formatAmount(getReceiptAmountLocalTotal(receipt))}
    </PaymentInfo>
  );
}

function getLabelValue(country: Country): string {
  switch (country) {
    case 'co':
      return 'Valor a pagar';
    default:
      return 'Valor:';
  }
}
